import { ApiInstance } from './base'

const ApiService = {
    getOrders(params) {
        return ApiInstance.get('/orders/order', { params })
    },
    getProducts(params) {
        return ApiInstance.get('/orders/product', { params })
    },
    getOrderDetail(id) {
        return ApiInstance.get(`/orders/${id}/detail`)
    },
    setOrderNote(id, payload) {
        return ApiInstance.put(`/orders/${id}/update`, payload)
    },
    createFilter(payload) {
        return ApiInstance.post('/orders/filter/create', payload)
    },
    updateFilter(id, payload) {
        return ApiInstance.patch(`/orders/filter/${id}`, payload)
    },
    deleteFilter(id) {
        return ApiInstance.delete(`/orders/filter/${id}`)
    },
    getFilters() {
        return ApiInstance.get('/orders/filter')
    },
    getFilter(id) {
        return ApiInstance.get(`/orders/filter/${id}`)
    },
    applyFilter(payload, params) {
        const queryString = params ? `?${new URLSearchParams(params).toString()}` : ''
        return ApiInstance.post(`/orders/filter${queryString}`, payload)
    },
    filterSort(payload) {
        return ApiInstance.post('/orders/filter/sort', payload)
    },
    updateCog(id, payload) {
        return ApiInstance.put(`/orders/${id}/update-cog`, payload)
    },
}

export default ApiService
